import React from 'react';

export default function Header() {
  return (
    
    <div className='d-flex align-items-center justify-content-between p-4 mb-4'>
     <div>
      <img src='https://merchify.in/asset/merchify-logo.svg' alt="wormhole"  /> 
     </div>
    </div>
   
  );
}